import React, { Suspense, memo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar/Sidebar";
import Navbar from "./components/Navbar/Navbar";
import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary";
import Loader from "@/components/Loader/Loader";
import styles from "./PostLogin.module.scss";

const PostLogin: React.FC = () => {
  const location = useLocation();

  return (
    <div className={styles.layout}>
      <div className={styles.mainContent}>
        <Sidebar />
        <div className={styles.rightSideContainer}>
          <Navbar />
          <div className={styles.outletDiv}>
            <Suspense fallback={<Loader />}>
              <ErrorBoundary>
                <Outlet key={location.pathname} />
              </ErrorBoundary>
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(PostLogin);
